module.exports = {
  News: 'news',
  Insights: 'insights',
  Education: 'education',
  'Success Stories': 'success-stories',
}
